import React from 'react';

// Types
import type { WBudgetItemView } from '@zola/svc-web-api-ts-client';

// Utils
import { handleBudgetRouteChange } from 'components/manage/budget/routes';
import {
  BudgetPaymentStatus,
  getBudgetPaymentStatus,
  mapDateToFormattedString,
  mapCostToFormattedString,
  mapPaymentsToWithin7DaysOrOverdue,
} from 'components/manage/budget/util/mappers';

// Styles
import {
  UpcomingReminders,
  UpcomingReminder,
  ReminderCostTime,
  ViewDetailsLink,
} from '../BudgetItemView.styles';

type BudgetItemViewUpcomingPaymentsProps = {
  payments: WBudgetItemView['payments'];
  itemUuid: string;
  handleStashChanges: () => void;
};

const BudgetItemViewUpcomingPayments = ({
  payments,
  itemUuid,
  handleStashChanges,
}: BudgetItemViewUpcomingPaymentsProps) => {
  const upcomingWithin7DaysOrOverdue = mapPaymentsToWithin7DaysOrOverdue(payments);

  if (!upcomingWithin7DaysOrOverdue.length) return null;

  const handleStashChangesAndChangeRoute = (paymentUuid?: string) => {
    handleStashChanges();
    handleBudgetRouteChange(`/item/${itemUuid}/payment/${paymentUuid}`, false);
  };

  return (
    <UpcomingReminders>
      {upcomingWithin7DaysOrOverdue?.map(payment => {
        const isOverdue = getBudgetPaymentStatus(payment) === BudgetPaymentStatus.OVERDUE;
        const handleViewDetails = () => handleStashChangesAndChangeRoute(payment.uuid);
        return (
          <UpcomingReminder isOverdue={isOverdue} key={payment.uuid}>
            <div>
              <div>{isOverdue ? 'Overdue payment' : 'Payment reminder'}</div>
              <ReminderCostTime>
                {mapCostToFormattedString(payment.amount_cents)} due on{' '}
                {mapDateToFormattedString(isOverdue ? payment.due_at : payment.remind_at)}
              </ReminderCostTime>
            </div>
            <ViewDetailsLink inline onClick={handleViewDetails} role="button" isOverdue={isOverdue}>
              View details
            </ViewDetailsLink>
          </UpcomingReminder>
        );
      })}
    </UpcomingReminders>
  );
};

export default BudgetItemViewUpcomingPayments;
